import { FSMCommonTransitions } from '../FSM/shared/constants'

export const AUTH = '/auth' //Used in BackButtonShared component
export const AUTH_REGULAR = '/auth/regular'
export const OFFER_VERIFY = '/verify'
export const SIGN_IN_BANK_ID = '/authBankId'
export const CLAIMS = '/claims'
export const FNOL_WINDSHIELD = '/fnol/windshield'
export const FNOL_COLLISION = '/fnol/collision'
export const FNOL_ROADSIDE_ASSISTANCE = '/fnol/roadside-assistance'
export const FNOL_OTHER = '/fnol/other'

export const AUTH_CHOICE = `/${FSMCommonTransitions.AUTH_CHOICE}`
export const AUTH_AGENT = `/${FSMCommonTransitions.AUTH_AGENT}`
export const REGULAR = `/${FSMCommonTransitions.AUTH_REGULAR}`
export const DONE = `/${FSMCommonTransitions.QB_PURCHASED_DONE}`
export const MILEAGE = `/${FSMCommonTransitions.QB_PURCHASED_MILEAGE}`
export const ERROR = `/${FSMCommonTransitions.ERROR}`
export const FAILURE = `/${FSMCommonTransitions.QB_PURCHASED_FAILURE}`
export const PAYMENT_ERROR = `/${FSMCommonTransitions.QB_PURCHASED_ERROR}`

export const POLICY_DONE = `/${FSMCommonTransitions.POLICY_DONE}`

// Instabank QB "closed" landing page (purchase removed) — see brand/instabank QBClosedPage.
export const CLOSED = '/closed'

// Payment callback URLs. react-router v5 expressed these as one regex route
// (`/payment/:paymentStatus(success|error|failure|cancel)`); v6+ dropped regex param syntax, so the
// status list is the single source of truth for both the routes in `App.tsx` and the "is this a
// callback URL" test used here and in `FSM/util.ts`.
export const PAYMENT_CALLBACK_STATUSES = ['success', 'error', 'failure', 'cancel'] as const

export const PAYMENT_CALLBACK_PATH_REGEXP = new RegExp(
  `^/payment/(${PAYMENT_CALLBACK_STATUSES.join('|')})$`
)

export enum FlowType {
  qb,
  mypages,
}
